import { activityReducer as activity, ActivityState } from './activity';
import {
  activityNotificationsReducer as activityNotifications,
  ActivityNotificationsState,
} from './activityNotifications';
import { duplicatesReducer as duplicates, DuplicatesState } from './duplicates';
import { archiveSearchReducer as archiveSearch, ArchiveSearchState } from './archiveSearch';
import { birthdaysReducer as birthdays, BirthdaysState } from './birthdays';
import { contactsReducer as contacts, ContactsState } from './contacts';
import { ContactFormsState } from './contactForms';
import { ContactsAtOrganizationState } from './contactsAtOrganization';
import { groupsReducer as groups, GroupsState } from './groups';
import { highlightsReducer as highlights, HighlightsState } from './highlights';
import { ImportsReducer as imports, ImportsState } from './imports';
import { momentsReducer as moments, MomentsState } from './moments';
import { publicProfileReducer as publicProfile, PublicProfileState } from './publicProfile';
import { nexusReducer as nexus, NexusState } from './nexus';
import { notesReducer as notes, NotesState } from './notes';
import { reconnectReducer as reconnect, ReconnectState } from './reconnect';
import { searchReducer as search } from './search/search';
import { shareStatusesReducer as shareStatuses, ShareStatusesState } from './shareStatuses';
import { starredReducer as starred } from './starred';
import { timelineReducer as timelines, TimelinesState } from './timeline';
import { userSettingsReducer as userSettings, UserSettingsState } from './userSettings';
import Starred from '@repo/utils/models/Starred';
import { createSearchReducer } from './search/createSearchReducer';
import { SearchState } from '@repo/utils/types';
import { locationsReducer as locations, LocationsState } from './locations';
import { groupActivityReducer as groupActivity, GroupActivityState } from './groupActivity';
import {
  expandableActivityItemsReducer as expandableActivityItems,
  ExpandableActivityItemsState,
} from './expandableActivityItems';
import { sourcesReducer as sources, SourcesState } from './sources';

export interface AppData {
  activity: ActivityState;
  activityNotifications: ActivityNotificationsState;
  expandableActivityItems: ExpandableActivityItemsState;
  adHocSearch: SearchState;
  allPeopleSearch: SearchState;
  mentionSearch: SearchState;
  archiveSearch: ArchiveSearchState;
  birthdays: BirthdaysState;
  contacts: ContactsState;
  contactForms: ContactFormsState; // not exported from the index below b/c it isn't currently used in the web app...
  contactsAtOrganization: ContactsAtOrganizationState; // not exported from the index below b/c it isn't used in the web app...
  duplicates: DuplicatesState;
  groups: GroupsState;
  groupActivity: GroupActivityState;
  highlights: HighlightsState;
  imports: ImportsState;
  locations: LocationsState;
  moments: MomentsState;
  nexus: NexusState;
  notes: NotesState;
  publicProfile: PublicProfileState;
  reconnect: ReconnectState;
  search: SearchState;
  shareStatuses: ShareStatusesState;
  sources: SourcesState;
  starred: Starred;
  timelines: TimelinesState;
  userSettings: UserSettingsState;
}

export default {
  activity,
  activityNotifications,
  expandableActivityItems,
  adHocSearch: createSearchReducer('adHocSearch', {
    sorting: { name: 'closeness', direction: 'desc' },
  }),
  allPeopleSearch: createSearchReducer('allPeopleSearch', {
    sorting: { name: 'lastName', direction: 'asc' },
  }),
  mentionSearch: createSearchReducer('mentionSearch', {
    sorting: { name: 'closeness', direction: 'desc' },
  }),
  archiveSearch,
  birthdays,
  contacts,
  duplicates,
  groups,
  groupActivity,
  highlights,
  imports,
  locations,
  moments,
  nexus,
  notes,
  publicProfile,
  reconnect,
  search,
  shareStatuses,
  sources,
  starred,
  timelines,
  userSettings,
};
